import InteractiveSimpleCategoryCard from './InteractiveSimpleCategoryCard'

interface CategoryBlockProps {
  title: string
  categoryId: number
  items: any[]
  itemType: 'subcategories' | 'cards'
  className?: string
  isAvailableContent?: boolean
  maxItems?: number
  onCategoryClick?: (categoryId: number) => void
  onSeeAllClick?: (categoryId: number) => void
  onToggleFavorite?: (itemId: string) => void
  favorites?: string[]
  hasSubscription?: boolean
  searchQuery?: string
  onScrollToTop?: () => void
}

const CategoryBlock = ({
  title,
  categoryId,
  items,
  itemType,
  className = 'category-block',
  isAvailableContent = false,
  maxItems,
  onCategoryClick,
  onSeeAllClick,
  onToggleFavorite,
  favorites = [],
  hasSubscription,
  searchQuery = '',
  onScrollToTop,
  lockContent = false,
}: CategoryBlockProps) => {
  const gridClass = isAvailableContent
    ? 'available-content-grid'
    : 'categories-grid'

  return (
    <div className={className}>
      <div className="category-block-header">
        <h3>{title}</h3>
        {!isAvailableContent && (
          <button
            type="button"
            onClick={() => {
              onScrollToTop?.()
              onSeeAllClick?.(categoryId)
            }}
            className="see-all-link"
          >
            Все
          </button>
        )}
      </div>

      <div className={gridClass}>
        {items
          .slice(0, maxItems ?? (isAvailableContent ? undefined : 6))
          .map(item => {
            const itemId = (
              itemType === 'subcategories' ? item.category_id : item.card_id
            ).toString()
            return (
              <InteractiveSimpleCategoryCard
                key={itemId}
                item={item}
                showingType={itemType}
                onCategoryClick={onCategoryClick}
                onToggleFavorite={
                  itemType === 'cards' ? onToggleFavorite : undefined
                }
                isFavorite={
                  itemType === 'cards' ? favorites.includes(itemId) : false
                }
                hasSubscription={hasSubscription}
                searchQuery={searchQuery}
                onScrollToTop={onScrollToTop}
                lockContent={lockContent}
              />
            )
          })}
      </div>

      {items.length === 0 && (
        <div className="empty-state">
          <p>
            {itemType === 'subcategories'
              ? 'Подкатегории не найдены'
              : 'Карточки не найдены'}
          </p>
        </div>
      )}
    </div>
  )
}

export default CategoryBlock
